// src/hooks/useAuth.js
import { configureToken, getUserToken, signUp, getProfile, resetPassword, googleLogin } from 'api';
import { useProfile } from '../context';
import { useNavigate } from 'react-router-dom'

export const useAuth = () => {
  const { setProfile, resetContext } = useProfile();
  const navigate = useNavigate()

  const doLogin = async (data) => {
    try {
      const response = await getUserToken(data);
      
      if (!response || !response.access) {
        console.error('Invalid response from getUserToken:', response);
        throw new Error('Invalid credentials');
      }
      
      const token = response.access;
      localStorage.setItem('token', response.access);
      localStorage.setItem('refreshToken', response.refresh);
      configureToken(token);
    
      // Fetch profile after successful login
      const profile = await getProfile();
      setProfile(profile);
      
      return response;
    } catch (error) {
      console.error('doLogin error:', error);
      throw error; // Re-throw to be handled by the mutation's onError
    }
  };

  const doSignup = async (data) => {
    try {
      const response = await signUp(data);
      return response;
    } catch (error) {
      console.error('doSignup error:', error);
      throw error;
    }
  };

  const doReset = async (data) => {
    try {
      const response = await resetPassword(data);
      return response;
    } catch (error) {
      console.error('doReset error:', error);
      throw error;
    }
  };

  const doLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    resetContext(); // Perform any additional context reset using useLogout
    navigate(`/`);
  };

// Update your useAuth hook to include Google login
const doGoogleLogin = async (credentialResponse) => {
  try {
    // The key issue is here - change access_token to id_token
    const params = {
      id_token: credentialResponse.credential
    };
    
    // Add community parameters if available
    if (credentialResponse && credentialResponse.action) {
      params.slug = credentialResponse.slug;
      params.action = credentialResponse.action;
    }
    
    // Call the doGoogleLogin with our parameters
    const response = await googleLogin(params);
    
    const token = response.access;
    localStorage.setItem('token', response.access);
    localStorage.setItem('refreshToken', response.refresh);
    configureToken(token);
    
    // Fetch profile after successful login
    const profile = await getProfile();
    setProfile(profile);
    
    return response;
  } catch (error) {
    console.error("Google login error:", error);
    throw error;
  }
};

  return { doLogin, doSignup, doReset, doLogout, doGoogleLogin };
};
